import http from "../http-common";

class LoggerDataService {
  getAll() {
    return http.get("/logs");
  }

  get(id) {
    return http.get(`/logs/${id}`);
  }

  create(data) {
    return http.post("/", data);
  }

}

export default new LoggerDataService();